import { useLayoutEffect } from "react";
import { sessionStorage } from "./globals";

export function getUserLanguage() {
  return sessionStorage.getItem("user-language");
}
export default function usePersistUserLanguage(language) {
  // HACK! 🤢
  // useLayoutEffect is used here to try to ensure this hook runs before any useEffects lower in the tree.
  // i.e. we want to make sure we've set the initial 'language' to local storage before any fetches are
  //      kicked off by child components via useEffects.
  // Using a useEffect here wouldn't guarantee that: https://github.com/facebook/react/issues/15281
  useLayoutEffect(() => {
    sessionStorage.setItem("user-language", language);
  }, [language]);
}
